import { jsx as e, jsxs as t } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/flags/english/index.tsx
var n = () => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Слой 1",
	viewBox: "0 0 512 512.01",
	children: [/* @__PURE__ */ e("path", {
		fill: "#f0f0f0",
		d: "M256 512c141.38 0 256-114.63 256-256S397.39 0 256 0 0 114.64 0 256s114.62 256 256 256z"
	}), /* @__PURE__ */ t("g", {
		fillRule: "evenodd",
		children: [/* @__PURE__ */ e("path", {
			fill: "#d80027",
			d: "M474.17 122.33H244.49V55.48h170.66a255.89 255.89 0 0159.02 66.85zM512 256H244.63v-66.83h258.56A256.28 256.28 0 01512 256zM256 512a254.3 254.3 0 00159.29-55.6H96.72A254.19 254.19 0 00256 512zm218.45-122.3H37.55a253.31 253.31 0 01-28.73-66.84h494.36a253.17 253.17 0 01-28.73 66.84z"
		}), /* @__PURE__ */ e("path", {
			fill: "#0052b4",
			d: "M118.85 39.84h-.23V40zm0 0H142l-21.81 15.65 8.25 25.6-21.76-15.65-21.62 15.65L92.17 59a256.08 256.08 0 00-49.49 55.5h7.54l-13.8 10-6.26 11 6.54 20.34-12.37-9-8.53 19.86 7.11 22.3h27l-21.46 15.81 8.25 25.6-21.76-15.65-12.8 9.38A237.13 237.13 0 000 256h256V0a254.85 254.85 0 00-137.15 39.84zm9.54 190.44l.19.15h-.14zm-8.21-25.46l8.21 25.46-21.72-15.5-21.76 15.65 8.25-25.6-21.76-15.65h27l8.25-25.6 8.25 25.6h27zm.15-74.52l8.25 25.6-21.76-15.65-21.76 15.65 8.25-25.6-21.76-15.65h27l8.25-25.6 8.25 25.6h27zm78.36 84.48l21.76 15.65-8.25-25.6 21.8-15.65h-27l-8.25-25.6-8.25 25.6h-27l21.76 15.65-8.25 25.6zm13.51-84.48l8.25 25.6-21.76-15.65-21.76 15.65 8.25-25.6-21.76-15.65h27l8.25-25.6 8.25 25.6h27zm8.25-48.93l-8.25-25.6L234 40.12h-27l-8.25-25.6-8.25 25.6h-27l21.76 15.65-8.25 25.6 21.76-15.65z"
		})]
	})]
});
export { n as EnFlag };

//# sourceMappingURL=index.js.map